export const initialState = {
  newsList: [],
  activeNewsDetail: {},
};
